import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './CountryFlagDropdown.css';

const countries = [
  { code: 'EN', lang: 'en', label: 'English' },
  { code: 'DE', lang: 'de', label: 'German' },
  { code: 'ZH', lang: 'zh', label: 'Chinese' },
  { code: 'FR', lang: 'fr', label: 'French' },
  { code: 'ES', lang: 'es', label: 'Spanish' },
  { code: 'NL', lang: 'nl', label: 'Dutch' },
  { code: 'FR-CA', lang: 'fr-ca', label: 'Canadian French' },
];



export const CountryFlagDropdown: React.FC = () => {
  const initialLang = localStorage.getItem('lang') || 'en';

  const [open, setOpen] = useState(false);
  const [selectedLang, setSelectedLang] = useState(initialLang);
  const { i18n } = useTranslation();
  const menuRef = useRef<HTMLDivElement>(null);

  const handleSelect = (countryCode: string, lang: string) => {
    setSelectedLang(lang);
    localStorage.setItem('lang', lang);
    localStorage.setItem('flag', countryCode);
    i18n.changeLanguage(lang);
    setOpen(false);
  };

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div className="flag-dropdown" ref={menuRef}>
      <button className="flag-button" onClick={() => setOpen(!open)}>
      🌐 {selectedLang.toUpperCase()} ▾
      </button>
      {open && (
        <div className="flag-menu">
          {countries.map((c) => (
            <div key={c.code} className="flag-item" onClick={() => handleSelect(c.code, c.lang)}>
              {c.code.toUpperCase()}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CountryFlagDropdown;
